import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { ScenePreviewProps } from "./ScenePreview";
const ScenePreview = lazy(() => import("./ScenePreview").then(module => ({ default: module.ScenePreview })));
export function mountScenePreview(slot: HTMLElement, props: ScenePreviewProps) {
  setStudioView("scene-preview", "scene-preview", <ScenePreview
      key={`${props.model.projectId}:${props.model.scene.id}:${props.model.sourceId}`}
      {...props}
    />);
}
